import { forwardRef, ForwardedRef } from "react";
import FaiInputRoot from "./FaiInputRoot";
import { useFaiController } from "../../context";
import { InputBaseProps } from "@mui/material/InputBase";

interface FaiInputProps extends InputBaseProps {
	error?: boolean;
	success?: boolean;
	disabled?: boolean;

	[key: string]: any;
}

const FaiInput = forwardRef((props: FaiInputProps, ref: ForwardedRef<any>) => {
	const {
		iconDirection = "left",
		size = "medium",
		error = false,
		success = false,
		disabled = false,
		...rest
	} = props;
	const [controller] = useFaiController();
	const { darkMode } = controller;

	return (
		<FaiInputRoot
			{...rest}
			ref={ref}
			ownerState={{
				size,
				error,
				success,
				disabled,
				darkMode,
				iconDirection,
			}}
		/>
	);
});

export default FaiInput;
